import { useEffect, useState, useCallback, useRef, useMemo } from 'react'
import './App.css'
import SingleCard from "./components/SingleCard";
import LevelSelect from "./components/LevelSelect";

const cardsList = {
    animals: [
        { "src": "/img/animals/bzhew.jpg", matched: false },
        { "src": "/img/animals/gagingezhi.jpg", matched: false },
        { "src": "/img/animals/gedgene.jpg", matched: false },
        { "src": "/img/animals/meingen.jpg", matched: false },
        { "src": "/img/animals/moewe.jpg", matched: false },
        { "src": "/img/animals/mozo.jpg", matched: false },
        { "src": "/img/animals/msegek.jpg", matched: false },
        { "src": "/img/animals/mzhewe.jpg", matched: false },
        { "src": "/img/animals/nijan.jpg", matched: false },
        { "src": "/img/animals/wakwshe.jpg", matched: false },
        { "src": "/img/animals/yabe.jpg", matched: false },
        { "src": "/img/animals/zhegak.jpg", matched: false },
        { "src": "/img/animals/gdede.jpg", matched: false },
        { "src": "/img/animals/gnebek.jpg", matched: false },
        { "src": "/img/animals/gnozhe.jpg", matched: false },
        { "src": "/img/animals/kno.jpg", matched: false },
        { "src": "/img/animals/mko.jpg", matched: false },
        { "src": "/img/animals/mshike.jpg", matched: false },
        { "src": "/img/animals/zheshko.jpg", matched: false },
        { "src": "/img/animals/espike.jpg", matched: false },
        { "src": "/img/animals/gaktenango.jpg", matched: false },
        { "src": "/img/animals/gedemi.jpg", matched: false },
        { "src": "/img/animals/gokoko.jpg", matched: false },
        { "src": "/img/animals/kekwse.jpg", matched: false },
        { "src": "/img/animals/sengo.jpg", matched: false },
        { "src": "/img/animals/moze.jpg", matched: false }
    ],
    colors: [
        { "src": "/img/colors/gizhgok-nade.jpg", matched: false },
        { "src": "/img/colors/mkedewa.jpg", matched: false },
        { "src": "/img/colors/mnwade.jpg", matched: false },
        { "src": "/img/colors/mskwa.jpg", matched: false },
        { "src": "/img/colors/skebgya.jpg", matched: false },
        { "src": "/img/colors/wabshkya.jpg", matched: false },
        { "src": "/img/colors/wjebgwa.jpg", matched: false },
        { "src": "/img/colors/wzawa_brown.jpg", matched: false },
        { "src": "/img/colors/wzawa_orange.jpg", matched: false },
        { "src": "/img/colors/wzawa_yellow.jpg", matched: false }
    ],
    bodyparts: [
        { "src": "/img/bodyparts/ndon.jpg", matched: false },
        { "src": "/img/bodyparts/njash.jpg", matched: false },
        { "src": "/img/bodyparts/njigwen.jpg", matched: false },
        { "src": "/img/bodyparts/nkaden.jpg", matched: false },
        { "src": "/img/bodyparts/nnech.jpg", matched: false },
        { "src": "/img/bodyparts/nnek.jpg", matched: false },
        { "src": "/img/bodyparts/nshkizhek.jpg", matched: false },
        { "src": "/img/bodyparts/nshtegwan.jpg", matched: false },
        { "src": "/img/bodyparts/ntog.jpg", matched: false },
        { "src": "/img/bodyparts/nzet.jpg", matched: false }
    ],
    opposites: [
        { "src": "/img/opposites/bkonya.jpg", matched: false },
        { "src": "/img/opposites/gizhget.jpg", matched: false },
        { "src": "/img/opposites/dbek-gizes.jpg", matched: false },
        { "src": "/img/opposites/gizes.jpg", matched: false },
        { "src": "/img/opposites/gzhate.jpg", matched: false },
        { "src": "/img/opposites/ksenya.jpg", matched: false },
        { "src": "/img/opposites/mno-bkonya.jpg", matched: false },
        { "src": "/img/opposites/mno-waben.jpg", matched: false },
        { "src": "/img/opposites/ndoki.jpg", matched: false },
        { "src": "/img/opposites/nneba.jpg", matched: false }
    ],
    nature: [
        { "src": "/img/nature/bonimget.jpg", matched: false },
        { "src": "/img/nature/datbek.jpg", matched: false },
        { "src": "/img/nature/getgadek.jpg", matched: false },
        { "src": "/img/nature/gizhek.jpg", matched: false },
        { "src": "/img/nature/gmeyamget.jpg", matched: false },
        { "src": "/img/nature/gzhiyaske.jpg", matched: false },
        { "src": "/img/nature/jigwekya.jpg", matched: false },
        { "src": "/img/nature/mishkosen.jpg", matched: false },
        { "src": "/img/nature/mtek.jpg", matched: false },
        { "src": "/img/nature/ngwankwet.jpg", matched: false },
        { "src": "/img/nature/noden.jpg", matched: false },
        { "src": "/img/nature/sen.jpg", matched: false },
        { "src": "/img/nature/waskonedo.jpg", matched: false },
        { "src": "/img/nature/wawasmomget.jpg", matched: false },
        { "src": "/img/nature/zagech.jpg", matched: false },
        { "src": "/img/nature/zheshke.jpg", matched: false }
    ],
    fruits: [
        { "src": "/img/fruits/anjes.jpg", matched: false },
        { "src": "/img/fruits/bneno.jpg", matched: false },
        { "src": "/img/fruits/bokto.jpg", matched: false },
        { "src": "/img/fruits/demen.jpg", matched: false },
        { "src": "/img/fruits/eshkwdemo.jpg", matched: false },
        { "src": "/img/fruits/mshimen.jpg", matched: false },
        { "src": "/img/fruits/zhomnen.jpg", matched: false },
        { "src": "/img/fruits/minen.jpg", matched: false }
    ]
}

let idCounter = 0;
const nextId = () => ++idCounter;

function App() {
    const [cards, setCards] = useState([])
    const [turns, setTurns] = useState(0)
    const [choiceOne, setChoiceOne] = useState(null)
    const [choiceTwo, setChoiceTwo] = useState(null)
    const [disabled, setDisabled] = useState(false)
    const [level, setLevel] = useState(null)
    const [timer, setTimer] = useState(0);
    const timerRef = useRef(null);

    const endGame = () => {
        setLevel(null);
        resetTurn();
        clearInterval(timerRef.current);
    }

    const shuffleCards = useCallback(() => {
        const cardImages = cardsList[level];
        const shuffled = [...cardImages];

        // Fisher-Yates shuffle
        for (let i = shuffled.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
        }

        // Pick first 8, duplicate each for pairs
        const selected = shuffled.slice(0, 8);
        const pairs = selected.flatMap(card => [
            { ...card, id: nextId() },
            { ...card, id: nextId() }
        ]);

        // Shuffle the pairs
        for (let i = pairs.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [pairs[i], pairs[j]] = [pairs[j], pairs[i]];
        }

        setChoiceOne(null);
        setChoiceTwo(null);
        setCards(pairs);
        setTurns(0);
    }, [level]);

    const handleChoice = useCallback((card) => {
        if (choiceOne && card.id === choiceOne.id) return;

        const flipSoundNumber = Math.floor(Math.random() * 6) + 1;
        const flipAudio = new Audio(`/flip${flipSoundNumber}.mp3`);
        flipAudio.volume = 0.5;
        flipAudio.play();

        choiceOne ? setChoiceTwo(card) : setChoiceOne(card);
    }, [choiceOne]);

    useEffect(() => {
        if (choiceOne && choiceTwo) {
            setDisabled(true);
            let isMatch;

            if (choiceOne.matchId && choiceTwo.matchId) {
                isMatch = choiceOne.matchId === choiceTwo.matchId;
            } else {
                isMatch = choiceOne.src === choiceTwo.src;
            }

            if (isMatch) {
                const audioSrc = (choiceOne.matchId ? choiceOne.matchId : choiceOne.src).replace('.jpg', '.mp3');
                const audio = new Audio(audioSrc);
                audio.play();

                setCards(prevCards => {
                    return prevCards.map(card => {
                        if (card.src === choiceOne.src || (card.matchId && card.matchId === choiceOne.matchId)) {
                            return {...card, matched: true}
                        } else {
                            return card
                        }
                    })
                });
                setTimeout(() => resetTurn(), 1000);
            } else {
                setTimeout(() => resetTurn(), 1000);
            }
        }
    }, [choiceOne, choiceTwo]);

    const resetTurn = () => {
        setChoiceOne(null)
        setChoiceTwo(null)
        setTurns(prevTurns => prevTurns + 1)
        setTimeout(() => setDisabled(false), 500);
    }

    const startTimer = useCallback(() => {
        setTimer(0);
        if(timerRef.current) clearInterval(timerRef.current);
        timerRef.current = setInterval(() => {
            setTimer((timer) => timer + 1);
        }, 1000);
    }, []);

    useEffect(() => {
        if (level) {
            shuffleCards();
            startTimer();
        }
        return () => clearInterval(timerRef.current);
    }, [level, shuffleCards, startTimer]);

    const matchedCards = cards.filter((card) => card.matched).length;

    useEffect(() => {
        if (matchedCards / 2 === 8) {
            clearInterval(timerRef.current);
        }
    }, [matchedCards]);

    const formatTime = useMemo(() => {
        const minutes = Math.floor(timer / 60);
        const seconds = timer % 60;
        const minutesStr = minutes < 10 ? `0${minutes}` : minutes;
        const secondsStr = seconds < 10 ? `0${seconds}` : seconds;
        return `${minutesStr}:${secondsStr}`;
    }, [timer]);

    return (
        <div className="App" style={{ maxWidth: level ? '800px' : '1140px' }}>
            <h1>Bodéwadmimwen Match Game</h1>
            {!level ? <LevelSelect setLevel={setLevel}/> : (
                <div>
                    <div className="tools">
                        <div className="tool-buttons">
                            <button onClick={shuffleCards}>
                                <i className="fa-sharp fa-solid fa-arrow-rotate-right"></i>
                                <span className="button-text">Restart</span>
                            </button>
                            <button onClick={endGame}>
                                <i className="fa-regular fa-cards-blank"></i>
                                <span className="button-text">Level Select</span>
                            </button>
                        </div>
                        <div className="scoreboard">
                            <p>Timer: {formatTime}</p>
                            <p>Turns: {turns}</p>
                        </div>
                    </div>

                    <div className="card-grid" style={{ gridTemplateColumns: 'repeat(4, 1fr)' }}>
                        {cards.map(card => (
                            <SingleCard
                                key={card.id}
                                card={card}
                                handleChoice={handleChoice}
                                flipped={card === choiceOne || card === choiceTwo || card.matched}
                                disabled={disabled}
                                level={level}
                            />
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}

export default App
